import React from 'react'
import { Route, Switch } from 'wouter'

import { CreateProductContent } from './create-content'

export function ProductGroup() {
  return (
    <div>
      <Switch>
        <Route path="/product/create-content">
          <CreateProductContent />
        </Route>
      </Switch>
    </div>
  )
}
